import React from "react";
import Layout from "../../../../Layout";
import HeaderReports from "../../../HeaderReports";
import ListUserDeleteActivity from "./ListUserDeleteActivity";
import SearchDeleteActivity from "../SearchDeleteActivity";

const UserDeleteActivity = () => {

  return (
    <Layout>
      <HeaderReports />
      <ListUserDeleteActivity />
      <SearchDeleteActivity />
    </Layout>
  );
};


export default UserDeleteActivity;
